export default __webpack_public_path__ + "static/s5-abb2b88c222ef0063692d13e62a54863.jpg";